const ON_MOUSE_OVER = 1;
const ALWAYS = 2;
const NEVER = 3;
export const CLASSIC_SHOW_INFO_VALUES = [ON_MOUSE_OVER, ALWAYS];
export const STRIP_SHOW_INFO_VALUES = [...CLASSIC_SHOW_INFO_VALUES, NEVER];
export const COMPACT_SHOW_INFO_VALUES = STRIP_SHOW_INFO_VALUES;
export const SHOW_INFO_VALUES = {
  ON_MOUSE_OVER,
  ALWAYS,
  NEVER
};
//# sourceMappingURL=show-info-values.js.map